module.exports = __webpack_public_path__ + "img/simulators.63587901.svg";